import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a67235a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer color-footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-heading-footer" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", { style: {"color":"white"} }, "João Vitor | Copyright ©2023 Todos os direitos reservados.")
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_3))
}